import { ExternalLink } from "lucide-react"
import type { IParcel } from "@/types/explore"

interface ExternalLinksProps {
  parcel: IParcel
  compact?: boolean
}

export const ExternalLinks = ({ parcel, compact }: ExternalLinksProps) => (
  <div className="flex gap-2">
    <a
      href={`https://immobilier.pappers.fr/?lat=${parcel.center?.[1]}&lon=${parcel.center?.[0]}&z=18.00&parcelle=${parcel.properties?.idu}`}
      target="_blank"
      rel="noopener noreferrer"
      className="flex-1 inline-flex items-center justify-center gap-1 text-sm font-medium text-primary hover:text-primary-dark border border-primary/20 rounded-sm py-1.5 hover:bg-primary-lighter transition-colors"
    >
      {compact ? "Pappers" : "Voir sur Pappers"}
      <ExternalLink className="w-3 h-3" />
    </a>
    <a
      href={`https://explore.data.gouv.fr/fr/immobilier?onglet=carte&filtre=tous&lat=${parcel.center?.[1]}&lng=${parcel.center?.[0]}&zoom=17.97`}
      target="_blank"
      rel="noopener noreferrer"
      className="flex-1 inline-flex items-center justify-center gap-1 text-sm font-medium text-primary hover:text-primary-dark border border-primary/20 rounded-sm py-1.5 hover:bg-primary-lighter transition-colors"
    >
      {compact ? "DVF" : "Voir sur le DVF"}
      <ExternalLink className="w-3 h-3" />
    </a>
  </div>
)
